<script lang="ts">
	import { devices_status } from 'src/stores';
	import { format } from 'svelte-i18n';

	import type { Device } from 'src/types/Device';

	import { rebooting_devices } from 'src/stores';

	import ModalPrompt from 'src/components/ModalPrompt.svelte';

	import { Alert, Button, toast } from '@Shelly/shelly-design-system';

	import { real_id } from 'src/helpers/interface_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { zwaveDeviceReboot } from 'src/services/xz_http_reqs';

	export let device: Device;

	$: isOnline = $devices_status?.[real_id(device?.id)]?.online;

	let showModal = false;
	let loading = false;

	const rebootDevice = async () => {
		if (loading) return;
		loading = true;

		const res = await zwaveDeviceReboot(device);
		if (res?.isok) {
			rebooting_devices.update(real_id(device.id));
			toast.open({
				type: 'success',
				title: $format('zwave_reboot_scc_toast', {
					default: 'Reboot command sent to the Z-Wave device.',
				}),
			});
		} else {
			toast.open({
				type: 'danger',
				title: $format('zwave_reboot_err_toast', {
					default: 'Failed to reboot the Z-Wave device.',
				}),
			});
		}

		loading = false;
	};

	$: modalProps = {
		title: $format('prompt_title_zwave_reboot', { default: 'Reboot device?' }),
		text: $format('prompt_text_zwave_reboot', {
			default:
				'Rebooting the Z-Wave device may briefly interrupt its controls. The gateway will send the reboot command to the node.',
		}),
		button_2: $format('button_cancel', { default: 'Cancel' }),
		button_1: $format('button_reboot_device', { default: 'Reboot device' }),
		callback: rebootDevice,
	};
</script>

<Alert
	class="mb-s"
	type="info"
	heading={$format('alert_heading_zwave_reboot', {
		default: 'Reboot this Z-Wave device through the gateway.',
	})}
/>

<Button {loading} disabled={!isOnline} size="m" width="full" on:click={() => (showModal = true)}>
	{capFirstChar($format('button_reboot', { default: 'Reboot' }))}
</Button>

{#if showModal}
	<ModalPrompt bind:showModal props={modalProps} />
{/if}
